import { StyleSheet } from 'react-native';

import { EPGConfig } from '../../types';

const getStyles = (config: EPGConfig) =>
    StyleSheet.create({
        container: {
            position: 'absolute',
            top: 0,
            left: 0,
            height: config.timebarHeight,
            width: config.channelWidth,
        },
    });

export default getStyles;
